import "./App.css";
import Navbar from "./components/Home/Navbar";
import Allroutes from "./pages/AllRoutes/AllRoutes";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Allroutes />
    </div>
  );
}

export default App;
